import axios from 'axios';
import FileDownload from 'js-file-download';
import { useEffect, useState } from 'react';
import styled from 'styled-components';



import { isMobile } from './services/utils';

import { message, Spin } from 'antd';
import './App.css';
import Btn from './img/anu-btn.png';
import HeaderBG from './img/header_bg.png';
import Logo from './img/anu-logo.png';
import BottomLogo from './img/anu-bottom-logo.png';
import BG from './img/anu-bg.png';


const BGFlex = styled.div`
  /* background-color: #2f2e2e; */
  background: transparent;
  background-image: url(${BG});
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;
  position: absolute;
  left:0;
  right:0;
  top:0;
  bottom:0;
  height: 100vh;
  max-width: 480px;
  margin:0 auto;
`;

const Wrapper = styled.div`
  width: 100%;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-flow: column;
  gap: 30px;
  position: relative;
`;

const Header = styled.header`
  height: 75px;
  width: 100%;
  max-width: 480px;
  position: fixed;
  top:0;
  left: 50%;
  transform: translateX(-50%);
  z-index: 100;
  background-image: url(${HeaderBG});
  background-repeat: no-repeat;
  background-size: cover;
`;

const ContentWrapper = styled.div`
  position: relative;
  min-width: 380px;
  max-width: 480px;
  height: 100%;
  z-index: 90;
  display: flex;
  flex-flow: column;
  align-items: center;
  justify-content: flex-start;
  padding-top: 85px;

  
`;

const ContentHeaderWrapper = styled.div`
  width: 100%;
  min-height: 85px;
  display: flex;
  flex-flow: column;
  align-items: center;
  justify-content: center;
  padding-top: 10px;
  white-space: pre-line;

  h3{
    font-family: SimplerPro-Black;
    text-align: center;
    font-size: 27px;
    margin:0;
    color: #fff;
    padding:0;
    line-height: 1.2;
  }

  h4{
    font-family: SimplerPro-Black;
    text-align: center;
    font-size: 15px;
    margin:0;
    color: #fff;
    padding:0;
  }
`;

const HeaderDivider = styled.div`
  width: 80%;
  height: 3px;
  background-color: #fecafd;
  margin: 25px 0;
`;

const SharingWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  z-index: 99;
  gap: 20px;
  position: relative;
  color: #fff;
  font-family: ploni-bold;
  font-size: 1rem;
  margin-top: 45px;
`;

// const VideoPlayer = styled.video`
//   background-color: #000;
//   box-shadow: 0px 0px 5px 5px #ff280050, 0px 1px 5px 5px #ff280050,
//     0px 0px 5px 0px #ff280050;
//   max-height: 35%;
//   /* width: 49%; */
//   z-index: 99;
//   border-radius: 15px;
//   margin-top: 15px;
// `;

const ImageView = styled.img`
  background-color: #000;
  box-shadow: 0px 8px 10px 2px rgba(0, 0, 0, 0.5);
  max-height: 90%;
  max-width: 90%;
  z-index: 99;
  border: 5px solid white;
  margin-top: 15px;
  margin-bottom: 15px;
`;

const ShareButton = styled.button`
  border: none;
  background-color: transparent;
  background-image: url(${Btn});
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;
  width: 146px;
  height:146px;
  position: relative;
  color: #fff;
  font-family: SimplerPro-Light;
  font-size: 1.3rem;
  line-height: 1.2;
  white-space: pre-line;
`;

const DownloadButton = styled.button`
  border: none;
  background-color: transparent;
  background-image: url(${Btn});
  background-repeat: no-repeat;
  background-size: cover;
  width: 146px;
  height:146px;
  position: relative;
  color: #fff;
  font-family: SimplerPro-Light;
  font-size: 1.3rem;
  /* padding-bottom: 5px; */
  white-space: pre-line;
`;


const BottomSection = styled.div`
  width: 90%;
  background-color: #fff;
  border: 1px solid white;
  border-radius: 15px;
  padding: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 25px;
`;

const LinksWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-flow: column;
  width: 70%;
  z-index: 99;
  gap: 10px;
  direction: rtl;

  h4{
    font-family: SEGOEUI;
    text-align: right;
    font-size: 17px;
    margin:0;
  }
  a{
    text-decoration: none;
    margin: 0;
  }
`;

const AppStoresLinksWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  gap: 10px;

  a{
    text-decoration: none;
    margin: 0;
  }
`;



const PUBLIC_SERVER_ADDRESS = '';

const TEXTS = {
  he: {
    title: "כאן תוכלו לשמור ולשתף\n את התמונה האישית שלכם",
    buttons: {
      download: "הורדה",
      share: "שמירה \nושיתוף"
    }
  },
  en: {
    title: "Here you can save \nand share your image",
    buttons: {
      download: "Download",
      share: "Save \nand\n Share"
    }
  }
}


function App() {
  const [fileUrl, setFileUrl] = useState();
  const [fileName, setFileName] = useState();
  const [language, setLanguage] = useState("he");
  const [shareDownloading, setShareDownloading] = useState(false);
  const [isEmail, setIsEmail] = useState(false);
  const [fileDownload, setFileDownload] = useState(false);

  const downloadFile = () => {
    setFileDownload(true);

    axios
      .get(`${fileUrl}?download=true`, {
        responseType: 'blob'
      })
      .then((response) => {
        const blob = new Blob([response.data], {
          type: 'image/jpeg'
        });

        setFileDownload(false);
        FileDownload(blob, fileUrl);
      });
  };


  const openSharingDialog = async () => {
    setShareDownloading(true);
    try {
      const blob = await fetch(`${fileUrl}?download=true`).then(res => res.blob());
      const shareData = {
        title: "",
        text: "",
        files: [
          new File([blob], fileName, {
            type: blob.type,
          }),
        ],
      }
      setShareDownloading(false);
      if (navigator.canShare(shareData)) {
        try {
          await navigator.share(shareData);
          console.log("File shared successfully");
        } catch (shareError) {
          if (shareError.name === 'AbortError') {
            console.log("Share was canceled");
          } else {
            console.error("Sharing failed:", shareError);
            message.error("Failed to share the file");
          }
        }
      }
    } catch (err) {
      setShareDownloading(false);
      message.error(`Error: cannot share file type`);
      console.log(`Error: cannot share file type, ${err}`);
    } finally {
      return;
    }
  }

  const getTitleByLanguage = () => {
    return TEXTS[language]?.title || "";
  }

  const getDownloadBtnByLanguage = () => {
    return TEXTS[language]?.buttons.download || "";
  }

  const getShareBtnByLanguage = () => {
    return TEXTS[language]?.buttons.share || "";
  }

  useEffect(() => {

    setTimeout(() => {
      const parameters = new URLSearchParams(window.location.search);
      const fileName = parameters.get('file');
      const lang = parameters.get('lang');

      if (lang) {
        setLanguage(lang);
        document.dir = lang === "he" ? "rtl" : "ltr";
      }

      if (fileName) {
        setFileName(fileName);
        setFileUrl(`${PUBLIC_SERVER_ADDRESS}/media/download/${fileName}`);
      }
    }, 500);
  }, []);

  return (
    <div className="App">

      {/* <ParticlesBackground /> */}
      <Header>
        <img
          style={{ position: "absolute", top: "50%", left: 25, transform: "translate(0, -50%)" }}
          src={Logo}
          alt="Anu logo"
          width="40%"
          height={"auto"} />
      </Header>
      {fileUrl && (
        <Wrapper>
          <BGFlex />

          <ContentWrapper>
            <ContentHeaderWrapper>
              <h3>{getTitleByLanguage()}</h3>
              {/* <h4>מורידים את התמונה ומשתפים עם חברים ומשפחה</h4> */}
              <HeaderDivider />
            </ContentHeaderWrapper>
            {/* <VideoPlayer
              width="auto"
              // height="35%"
              controls
              muted
              autoPlay
              playsInline
              preload="metadata"
            >
              <source
                src={`${fileUrl}${isIOS() ? '?download=true' : ''}#t=0.001`}
                type="video/mp4"
              />
              No video support.
            </VideoPlayer> */}
            <ImageView src={`${fileUrl}`} />{/*${isIOS() ? "?download=true" : ""}*/}

            {(!isMobile() || !navigator.share) &&
              <SharingWrapper>
                <DownloadButton onClick={downloadFile} >
                  {getDownloadBtnByLanguage()}
                </DownloadButton>
                {fileDownload && <Spin style={{
                  position: "absolute",
                  left: "50%",
                  top: "50%",
                  transform: "translate(-50%, -50%)"
                }} />}
              </SharingWrapper>}

            {(isMobile() && navigator.share) &&
              <SharingWrapper>
                <ShareButton onClick={openSharingDialog}>
                  {!shareDownloading && getShareBtnByLanguage()}
                </ShareButton>
                {shareDownloading && <Spin
                  style={{
                    position: "absolute",
                    left: "50%",
                    top: "50%",
                    transform: "translate(-50%, -50%)"
                  }} />}
              </SharingWrapper>}

            {isEmail && (null
              // <SharingWrapper>
              //   <EmailForm
              //     server={PUBLIC_SERVER_ADDRESS}
              //     setIsEmail={setIsEmail}
              //   />
              // </SharingWrapper>
            )}
            {/* <BottomSection>

              <LinksWrapper>
                <h4>להורדת אפליקציית הפניקס:</h4>
                <AppStoresLinksWrapper>
                  <a href="https://play.google.com/store/apps/details?id=com.digital_app">
                    <img src={GoogleStore} alt="googl play store link" />
                  </a>
                  <a href="https://apps.apple.com/il/app/%D7%A7%D7%91%D7%95%D7%A6%D7%AA-%D7%94%D7%A4%D7%A0%D7%99%D7%A7%D7%A1/id6450553401?l=he">
                    <img src={AppStore} alt="app store link" />
                  </a>
                </AppStoresLinksWrapper>
              </LinksWrapper>
              <img src={Smiley} alt="app store link" />
            </BottomSection> */}
            <img
              style={{ position: "absolute", bottom: 0, left: 0 }}
              src={BottomLogo}
              alt="Anu logo"
              width="40%"
              height={"auto"} />
          </ContentWrapper>
        </Wrapper>
      )}
    </div>
  );
}

export default App;
